
import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { PaginatorModule } from 'primeng/paginator';
import { BasicAction } from 'src/app/core-module/models/Audits/AuditResults/basic-action';
import { UtilService } from 'src/app/core-module/services/util.service';

@Component({
  selector: 'app-event-actions-list',
  standalone: true,
  imports: [FormsModule, ToggleSwitchModule, PaginatorModule],
  templateUrl: './event-actions-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './event-actions-list.component.scss'
})
export class EventActionsListComponent implements OnChanges {

  @Input() actions: BasicAction[] = [];
  @Input() loading: boolean = false;
  @Output() viewAction = new EventEmitter<number>();

  public showResolved: boolean = false;
  public pageSize: number = 5;
  public pageIndex: number = 0;

  constructor(public util: UtilService){}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['actions']) {
      this.actions = (this.actions || []).slice().sort((a,b) => {
        const aTime = a?.ActionDeadline ? new Date(a.ActionDeadline).getTime() : Number.MAX_SAFE_INTEGER;
        const bTime = b?.ActionDeadline ? new Date(b.ActionDeadline).getTime() : Number.MAX_SAFE_INTEGER;
        return aTime - bTime;
      });
    }
  }

  isOverdue(a: BasicAction): boolean{
    if (a.Resolved){ return false; }
    if (!a.ActionDeadline){ return false; }
    return this.util.stripTime(a.ActionDeadline) < this.util.stripTime(new Date());
  }

  isDueToday(a: BasicAction): boolean{
    if (a.Resolved){ return false; }
    if (!a.ActionDeadline){ return false; }
    return this.util.stripTime(a.ActionDeadline).toString() === this.util.stripTime(new Date()).toString();
  }

  resolvedDate(a: BasicAction): string{
    if (!a.ResolvedDate){ return ''; }
    return this.util.humanDate(a.ResolvedDate);
  }

  humanDate(date: Date): string{
    return this.util.humanDate(date);
  }

  get filteredActions(): BasicAction[] {
    return this.showResolved ? this.actions : (this.actions || []).filter(a => !a.Resolved);
  }

  get pagedActions(): BasicAction[] {
    const start = this.pageIndex * this.pageSize;
    return this.filteredActions.slice(start, start + this.pageSize);
  }

  onPageChange(event:any){
    this.pageIndex = event.page ?? 0;
    this.pageSize = event.rows ?? this.pageSize;
  }

  open(id:number){
    this.viewAction.emit(id);
  }
}
